import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Index/Navbar";
import Footer from "@/components/Index/Footer";
import { ArrowLeft, Clock, Compass } from "lucide-react";

const HowItWorks: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[#FFF8F6]">
      <Navbar />
      <main className="flex-grow flex items-center justify-center px-4 py-20">
        <div className="max-w-xl w-full text-center bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-red-100">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-red-50 text-[#B70100] text-sm font-semibold mb-6">
            <Clock className="w-4 h-4" />
            <span>Coming Soon</span>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 tracking-tight">
            How It Works
          </h1>
          <p className="text-gray-600 mb-8 leading-relaxed text-sm md:text-base">
            Halaman panduan belajar dan alur kursus Fluenesia sedang dalam tahap penyempurnaan. Kami akan segera menghadirkannya untuk Anda!
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#B70100] hover:bg-[#9a0100] text-white font-medium px-6 py-3 rounded-full transition-colors shadow-sm"
            >
              <ArrowLeft className="w-4 h-4" />
              Kembali ke Beranda
            </Link>
            <Link
              to="/program-selection"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white hover:bg-gray-50 text-gray-700 border border-gray-200 font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Compass className="w-4 h-4" />
              Lihat Program
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HowItWorks;
